var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import "./selection-card.scss";
import { useSelector } from "react-redux";
import { getRefundTypes } from "@frameworks/NCD/Utils/getRefundTypes";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
var SelectionCard = function (_a) {
    var selectedId = _a.selectedId, onSelect = _a.onSelect;
    var _b = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }), refundType = _b.refundType, refundNcdType = _b.refundNcdType, orderBookDetails = _b.orderBookDetails;
    var _c = __read(useState([]), 2), filterData = _c[0], setFilterData = _c[1];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (orderBookDetails && Object.keys(orderBookDetails).length > 0) {
            var data = getRefundTypes({
                refund_cancelled_rejected_id: (_a = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _a === void 0 ? void 0 : _a.refund_cancelled_rejected_id,
                refund_cancelled_rejected_type: (_b = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _b === void 0 ? void 0 : _b.refund_cancelled_rejected_type,
                refund_excessfunds_id: (_c = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _c === void 0 ? void 0 : _c.refund_excessfunds_id,
                refund_excessfunds_type: (_d = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _d === void 0 ? void 0 : _d.refund_excessfunds_type,
                refund_interestdividend_id: (_e = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _e === void 0 ? void 0 : _e.refund_interest_dividend_id,
                refund_interestdividend_type: (_f = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _f === void 0 ? void 0 : _f.refund_interest_dividend_type,
            });
            var refundData = (ESubProductIds === null || ESubProductIds === void 0 ? void 0 : ESubProductIds.NCD) === String((_g = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _g === void 0 ? void 0 : _g.category_code)
                ? refundNcdType
                : refundType;
            var allowedIds_1 = data.map(function (item) { return item === null || item === void 0 ? void 0 : item.id; });
            var filterData_1 = (_h = refundData === null || refundData === void 0 ? void 0 : refundData.data) === null || _h === void 0 ? void 0 : _h.filter(function (item) {
                return allowedIds_1.includes(item.id);
            });
            setFilterData(filterData_1);
        }
    }, [orderBookDetails]);
    return (React.createElement("div", { className: "selection-container z-index-1 " }, filterData === null || filterData === void 0 ? void 0 : filterData.map(function (option) {
        var _a;
        return (React.createElement("div", { key: option.id, className: "d-flex gap-2", onClick: function () {
                return onSelect({
                    id: option.id,
                    name: option.name,
                    refund_description: option.refund_description,
                });
            } },
            React.createElement("div", { className: "radio checkbox-width hand_cursor ".concat(selectedId === option.id ? "checked" : "") }),
            React.createElement("div", { className: "d-flex flex-column option ".concat(selectedId === option.id ? "selected" : "") },
                React.createElement("div", { className: "txt_blackOne1 DMSanN_14_400" }, option.name),
                React.createElement("div", { className: "DMSansNormal_12_400 txt-whispering-periwinkle" }, (_a = option.refund_description) !== null && _a !== void 0 ? _a : "-"))));
    })));
};
export default SelectionCard;
